import React from 'react';
import { TextLink } from '@dsg-tech/homefield-react';
import { FooterTaxonomy } from 'types/index';
import useLogger from 'hooks/useLogger';
import './ScoreMore.scss';

type Props = {
  score: FooterTaxonomy['Score Section'][0];
};

const ScoreMore = ({ score }: Props) => {
  const { error } = useLogger();

  try {
    const scoreMessages = score?.['Score Message'];

    return (
      <div className="footer-score-more hmf-display-flex hmf-flex-column hmf-px-xlg-m hmf-px-md-m hmf-py-md-xl hmf-px-s hmf-pt-m hmf-pb-xl">
        <h3 className="hmf-display-s hmf-text-align-center hmf-m-0 hmf-text-align-md-left hmf-px-l hmf-px-sm-0">
          {score.headline}
        </h3>
        {scoreMessages?.map((message) => {
          const emdata = `Footer_${message.line1text.replace(/[^A-Z0-9]+/gi, '')}`;
          return (
            <div className="score-card-item hmf-py-s" key={message.line1text.replace(' ', '-')}>
              <div className="hmf-body-bold-l">{message.line1text}</div>
              <div className="hmf-body-s">
                {`${message.line2text} `}
                <TextLink variant="inverse" size="small" href={message.link} data-em={emdata}>
                  {message.ctaText}
                </TextLink>
              </div>
            </div>
          );
        })}
      </div>
    );
  } catch (e) {
    error('Could not load ScoreMore - ', e);
    return null;
  }
};

export default ScoreMore;
